module.exports = __webpack_public_path__ + "img/facilities_05.b625fa00.jpg";